import { combineReducers } from 'redux';
import homeReducer from './home.reducer';
import cartReducer from './cart.reducer';

const reducer = combineReducers({
	homeReducer,
	cartReducer
});

export default reducer;
